const zones = [
    {
        code: "01",
        name: "Aurora",
        eta: "30-45 min",
        note: "Including Southlands, Saddle Rock & Tower Triangle",
    },
    {
        code: "02",
        name: "Parker",
        eta: "30-45 min",
        note: "Stonegate, Stroh Ranch, Pinery & Meridian",
    },
    {
        code: "03",
        name: "Denver",
        eta: "35-50 min",
        note: "DTC, Cherry Creek, Stapleton & Lowry",
    },
    {
        code: "04",
        name: "Centennial",
        eta: "30-45 min",
        note: "Willow Creek, Walnut Hills & Foxridge",
    },
];

export default function ServiceArea() {
    return (
        <section
            id="coverage"
            data-testid="coverage-section"
            className="border-b hairline bg-[#0a0a0a] text-white"
        >
            <div className="mx-auto max-w-[1400px] grid grid-cols-12">
                <div className="col-span-12 lg:col-span-5 px-6 md:px-12 py-14 md:py-20 border-r border-white/10">
                    <div className="font-mono-tech text-[11px] text-[#60a5fa] mb-6">
                        COVERAGE
                    </div>
                    <h2 className="font-display text-4xl md:text-5xl tracking-tighter leading-[0.95]">
                        Serving the <br />
                        <span className="text-[#60a5fa]">Denver Metro.</span>
                    </h2>
                    <p className="text-[#a1a1aa] mt-6 leading-relaxed">
                        Quiseo Auto Repair LLC services Aurora, Parker, Denver
                        and Centennial — six days a week, with 24/7 roadside
                        availability for emergencies.
                    </p>
                    <div className="mt-10 inline-flex items-center gap-3 border border-white/20 px-4 py-3 font-mono-tech text-[10px]">
                        <span className="w-2 h-2 bg-[#1d4ed8] animate-pulse" />
                        ON CALL · MON–SAT 7:00 – 19:00
                    </div>
                </div>

                <div className="col-span-12 lg:col-span-7 grid grid-cols-1 sm:grid-cols-2">
                    {zones.map((z) => (
                        <div
                            key={z.code}
                            data-testid={`zone-${z.code}`}
                            className="border-l border-b border-white/10 p-8 hover:bg-[#1d4ed8] transition-colors duration-150"
                        >
                            <div className="flex items-baseline justify-between mb-8">
                                <span className="font-mono-tech text-[11px] text-[#a1a1aa]">
                                    {z.code}
                                </span>
                                <span className="font-mono-tech text-[10px] text-white/70">
                                    ETA {z.eta}
                                </span>
                            </div>
                            <div className="font-display text-3xl mb-3">
                                {z.name}
                            </div>
                            <div className="text-[12px] text-white/60 leading-snug">
                                {z.note}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
